import { Directive } from '@angular/core';
import { BaseDirective } from '../../../_core/components/base.directive';

@Directive({
    selector: '[geneaFieldsetLegend]'
})
export class GeneaFieldsetLegendDirective extends BaseDirective {
    // This directive is simply a pointer that allows our GeneaFieldsetComponent to target the legend of the fieldset
 }